// -- AUTOGENERATED --

// eslint-disable-next-line no-unused-vars
import APIUtils from '@/util/apiutil'

import Axios from 'axios'
import NETVSConfig from '@/../netvs.config'

/* eslint-disable camelcase */
/* eslint-disable quote-props */
/* eslint-disable object-curly-spacing */
/* eslint-disable array-bracket-spacing */
/* eslint-disable object-shorthand */
export default {

  createParamsList () {
    return {'old': [ ], 'new': [ 'type', 'value', 'description']}
  },
  create (config, {type_new, value_new, description_new}) {
    const params = { 'new': { 'type': type_new, 'value': value_new, 'description': description_new}, 'old': { }}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/dns/fqdn/create`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
  deleteParamsList () {
    return {'old': [ 'value', 'ignore_onx', 'try_del_parent', 'force_del_ref_records'], 'new': [ ]}
  },
  delete (config, {value_old, ignore_onx_old = false, try_del_parent_old = true, force_del_ref_records_old = false}) {
    const params = { 'new': { }, 'old': { 'value': value_old, 'ignore_onx': ignore_onx_old, 'try_del_parent': try_del_parent_old, 'force_del_ref_records': force_del_ref_records_old}}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/dns/fqdn/delete`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
  list (config, { type, zone, is_own, gpk_list, label_list, tree_level, value_list, fetch_limit, fetch_offset, label_regexp, parent_value, value_regexp, filter_params_dict, sorting_params_list, is_empty_nonterminal, rr_chain_target_is_own, rr_chain_target_subnet_gfk_list }) {
    const params = APIUtils.denullify_dict({ 'type': type, 'zone': zone, 'is_own': is_own, 'gpk_list': (gpk_list === null) ? null : JSON.stringify(gpk_list), 'label_list': (label_list === null) ? null : JSON.stringify(label_list), 'tree_level': tree_level, 'value_list': (value_list === null) ? null : JSON.stringify(value_list), 'fetch_limit': fetch_limit, 'fetch_offset': fetch_offset, 'label_regexp': label_regexp, 'parent_value': parent_value, 'value_regexp': value_regexp, 'filter_params_dict': filter_params_dict, 'sorting_params_list': (sorting_params_list === null) ? null : JSON.stringify(sorting_params_list), 'is_empty_nonterminal': is_empty_nonterminal, 'rr_chain_target_is_own': rr_chain_target_is_own, 'rr_chain_target_subnet_gfk_list': (rr_chain_target_subnet_gfk_list === null) ? null : JSON.stringify(rr_chain_target_subnet_gfk_list)})
    const cnf = {}
    Object.assign(cnf, (config || {}).netdb_axios_config)
    cnf.params = params
    return Axios.get(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/dns/fqdn/list`, cnf)
  // eslint-disable-next-line comma-dangle
  },
  updateParamsList () {
    return {'old': [ 'value', 'try_del_parent'], 'new': [ 'type', 'value', 'description']}
  },
  update (config, {type_new, value_old, value_new, description_new, try_del_parent_old = true}) {
    const params = { 'new': { 'type': type_new, 'value': value_new, 'description': description_new}, 'old': { 'value': value_old, 'try_del_parent': try_del_parent_old}}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/dns/fqdn/update`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
}
